module.exports = __webpack_public_path__ + "img/8.750d5271.jpg";